import useformattedLocalizedText from '@frolight/hooks/useLocalizedFormattedText';

import PageLayout from '@frolight/components/PageLayout';
import usePageTitle from '@frolight/hooks/usePageTitle';
import Panel from '@frolight/components/Panel';
import TableOfContents from '@frolight/components/TableOfContents';

const PrivacyPolicy = () => {
  const { lftext } = useformattedLocalizedText();

  const title = lftext('pages.privacy_policy.title');

  usePageTitle(title);

  return (
    <PageLayout>
      <Panel
        size="huge"
        title={ <h1>{ title }</h1> }
      >
        <main>
          <p>
            {lftext('pages.privacy_policy.effective_as_of')}
          </p>
          <TableOfContents>
            <div>
              {lftext('pages.privacy_policy.content')}
            </div>
          </TableOfContents>
        </main>
      </Panel>
    </PageLayout>
  );

}

export default PrivacyPolicy;
